import React, { Fragment, useEffect, useState } from 'react'
import { Button, CircularProgress, Grid, Typography } from '@mui/material'
import { GenericTable } from '../../_EOS/Table/GenericTable'
import { TableHeaderConfigWithType } from '../../_EOS/Table'
import { usePagination } from '../../../hooks/usePagination'
import { useApi } from '../../../hooks/useApi'
import { ApiResponse } from '../../../typings/ApiResponse'
import { getPickingRouteRelated } from '../api'
import { Status } from '../../../hooks/useFetchState'
import { ListItemInfo } from '../../Picking/ListItemInfo'
import { ePickingRouteStates } from '../api/types'

export interface PickingRoutesRelated {
  pickingRouteId: number
  lpn: string
  pickingRouteStateId: number
  validationStatusId: number
}

interface PickingRouteRelatedDialogInfoProps {
  pickingRouteId: number
  isConfigValidateRelatedRoutes: boolean
  allRoutesPickingFinalize: boolean
  closeModal: () => void
  executeStartPickingValidate: (pickingRouteId?: string) => void
}

export const TableHeaderConfig = () => {
  const table: TableHeaderConfigWithType<PickingRoutesRelated>[] = [
    {
      field: 'pickingRouteId',
      title: 'Ruta de Picking',
      sortable: false
    },
    { field: 'lpn', title: 'LPN', sortable: false },
    { field: 'zoneName', title: 'Zona', sortable: false },
    {
      field: 'pickingRouteStateId',
      title: 'Estado de la ruta',
      formater: (_pickingRouteId: number | string, row) =>
        renderPickingRouteStateId(row!)
    }
  ]

  return table
}

const renderPickingRouteStateId = (
  pickingrouterelated: PickingRoutesRelated
) => {
  const { validationStatusId, pickingRouteStateId } = pickingrouterelated
  const enValidacion = 2
  const validada = 3

  if (validationStatusId !== validada) {
    switch (pickingRouteStateId) {
      case ePickingRouteStates.Creada:
        return <Typography>Creada</Typography>
      case ePickingRouteStates.Iniciada:
        return <Typography>Picking Iniciado</Typography>
      case ePickingRouteStates.Finalizada:
        return <Typography>Picking Finalizado</Typography>
      default:
        break
    }
  }

  if (pickingRouteStateId === ePickingRouteStates.Finalizada) {
    switch (validationStatusId) {
      case enValidacion:
        return <Typography>En validación</Typography>
      case validada:
        return <Typography>Validada</Typography>
    }
  }

  return <Typography>Sin estado</Typography>
}

export const PickingRouteRelatedDialogInfo: React.FC<
  PickingRouteRelatedDialogInfoProps
> = ({
  pickingRouteId,
  isConfigValidateRelatedRoutes,
  allRoutesPickingFinalize,
  closeModal,
  executeStartPickingValidate
}) => {
  const [loading, setLoading] = useState<boolean>(false)
  const { state, callApi } = useApi<ApiResponse<PickingRoutesRelated>>()
  const configsHeaders = TableHeaderConfig()

  const pagination = usePagination(10)

  const requestPickingRouteRelated = (page?: number, pageSize?: number) => {
    callApi(getPickingRouteRelated(pickingRouteId, page, pageSize)).catch(
      (error) => {
        console.log(error)
      }
    )
  }

  const handlePaginationChange = (page: number, pageSize: number) => {
    // If the pageSize is different, we should set page 0
    const auxPage = pagination.pageSize !== pageSize ? 0 : page

    requestPickingRouteRelated(auxPage, pageSize)

    pagination.setPagination(auxPage, pageSize)
  }

  useEffect(() => {
    pagination.setPagination(0, pagination.pageSize)

    requestPickingRouteRelated(0, pagination.pageSize)
  }, [])

  return (
    <Fragment>
      <Grid container spacing={2}>
        <Grid
          item
          xs={12}
          md={12}
          style={{ display: 'flex', justifyContent: 'center' }}
        >
          <Typography variant='h1' style={{ fontWeight: 'bold' }}>
            <ListItemInfo primary='No puedes validar esta ruta' secondary='' />
          </Typography>
        </Grid>

        <Grid
          item
          justifyContent='flex-start'
          xs={12}
          md={12}
          style={{
            display: 'flex',
            paddingLeft: '30px',
            paddingRight: '30px'
          }}
        >
          <Typography variant='body1' style={{ fontWeight: 'bold' }}>
            Ya que cuenta con rutas relacionadas las cuales están pendientes de
            picking
          </Typography>
        </Grid>
        <Grid
          justifyContent='flex-start'
          item
          xs={12}
          md={12}
          style={{ display: 'flex', paddingLeft: '30px', paddingRight: '30px' }}
        >
          <Typography
            variant='body1'
            style={{
              fontWeight: 'bold'
            }}
          >
            Rutas Relacionadas:
          </Typography>
        </Grid>
      </Grid>

      <Grid container spacing={2}>
        <Grid item xs={12}>
          {(state.data?.items === undefined ||
            state.data?.items.length === 0) && (
            <Typography variant='h6'>Sin rutas Relacionadas</Typography>
          )}
        </Grid>
        <Grid
          item
          xs={12}
          style={{ display: 'flex', justifyContent: 'center' }}
        >
          {state.data?.items && state.data?.items.length >= 1 && (
            <GenericTable<PickingRoutesRelated>
              dense={true}
              headersConfig={configsHeaders}
              IDKey={'pickingRouteId'}
              data={state.data?.items}
              pagination={{
                totalItem: state.data?.totalItems || 0,
                page: pagination.page,
                pageSize: pagination.pageSize
              }}
              onPaginationChange={handlePaginationChange}
              isLoading={state.status === Status.Loading}
            />
          )}
        </Grid>
      </Grid>

      {!isConfigValidateRelatedRoutes && !allRoutesPickingFinalize && (
        <Grid container spacing={2}>
          {isConfigValidateRelatedRoutes && !allRoutesPickingFinalize && (
            <Grid
              item
              xs={12}
              style={{ display: 'flex', justifyContent: 'center' }}
            >
              <Button
                type='button'
                variant='contained'
                color='primary'
                onClick={() => closeModal()}
              >
                Aceptar
              </Button>
            </Grid>
          )}
          <Grid
            item
            xs={6}
            style={{ display: 'flex', justifyContent: 'center' }}
          >
            <Button
              variant='contained'
              style={{
                color: 'white',
                background: 'green',
                display: 'flex',
                justifyContent: 'center'
              }}
              onClick={() => closeModal()}
            >
              Regresar a la validación
            </Button>
          </Grid>
          <Grid
            item
            xs={6}
            style={{ display: 'flex', justifyContent: 'center' }}
          >
            <Button
              startIcon={
                loading ? <CircularProgress size={20} color='inherit' /> : null
              }
              variant='contained'
              color='primary'
              onClick={() => {
                setLoading(true)
                executeStartPickingValidate(pickingRouteId.toString())
                setLoading(false)
              }}
            >
              Deseo continuar con la validación
            </Button>
          </Grid>
        </Grid>
      )}
    </Fragment>
  )
}
